<template>
    <div class="tms-container">
        <Layout type="TMS" name="商标注册">
            <product-buy slot="buy" :baseInfo="baseInfo" type="tms" @buy="onBuy" @ask="onAsk">
            <div class="form-data-container" slot="form">
                <div class="form-item">
                <div class="form-label">注册类型：</div>
                <div class="form-content">
                    <div
                    :class="['select-item', item.value === typeSelected ? 'be-selected' : '']"
                    v-for="(item, index) in selectDatasource" :key="index"
                    @click="onSelectType(item)">
                    <div>{{item.text}}</div>
                    <img class="selected-img" v-if="item.value === typeSelected" src="../assets/selected.png">
                    </div>
                </div>
                </div>
                <div class="form-item">
                <div class="form-label">服务特点：</div>
                <div class="form-content">
                    <ul class="form-list">
                    <li v-for="(item, index) in baseInfo.serviceAdvantage" :key="index">{{item}}</li>
                    </ul>
                </div>
                </div>
            </div>
            </product-buy>
            <product-intro slot="intro">
            <div class="product-info-content tms-content" slot="content">
                <div class="info-item-content tms-title-content" ref="intro">
                <h2 class="tms-intro-title">为什么要注册商标</h2>
                <div class="tms-intro">
                    <div class="tms-intro-item" v-for="(item, index) in intro" :key="index">
                    <img :src="item.icon">
                    <div class="tms-intro-text">
                        <h4>{{item.title}}</h4>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content advantage-content" ref="advantage">
                <h2 class="advantage-title">服务优势</h2>
                <div class="tms-advantage">
                    <div class="tms-advantage-item" v-for="(item, index) in advantage" :key="index">
                    <img :src="item.icon">
                    <div class="tms-advantage-text">
                        <h4>{{item.title}}</h4>
                        <div class="line"></div>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content process-content" ref="process">
                <h2 class="process-title">办理流程</h2>
                <div class="tms-process tms-auxiliary-process">
                    <img class="process-title-img" src="../assets/fuzhu_xiadan.png">
                    <img class="process-auxiliary-img" src="../assets/tms_liucheng.png">
                    <div class="tms-process-content">
                    <div class="tms-process-item" v-for="(item, index) in process.auxiliary" :key="index">
                        <h4>{{item.title}}</h4>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                <div class="tms-process tms-self-process">
                    <img class="process-title-img" src="../assets/zizhu_xiadan.png">
                    <div class="tms-process-content">
                    <div class="tms-process-item" v-for="(item, index) in process.self" :key="index">
                        <img class="point-img" src="../assets/tms_jiantou.png" v-if="index !== process.self.length - 1">
                        <h4>{{item.title}}</h4>
                        <p>{{item.des}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content materials-content" ref="materials">
                <h2 class="materials-title">办理材料</h2>
                <div class="tms-materials">
                    <div class="tms-materials-item" v-for="(item, index) in materials" :key="index">
                    <img :src="item.icon">
                    <h4>{{item.title}}</h4>
                    <div class="materials-text">
                        <p v-for="(desItem, index) in item.des" :key="index">{{desItem}}</p>
                    </div>
                    </div>
                </div>
                </div>
                <div class="info-item-content problem-content tms-problem" ref="problem">
                <h2 class="problem-title">常见问题</h2>
                <img class="problem-icon" src="../assets/problem_icon.png">
                <div class="problem-item-content">
                    <div class="problem-item" v-for="(item, index) in problem" :key="index">
                    <h4>{{item.title}}</h4>
                    <p v-if="item.type === 'cantRegis'">
                        <a href="http://sbj.cnipa.gov.cn/zcfg/sbflfg/201911/t20191122_308740.html" target="_blank">《中华人民共和国商标法》</a>
                        根据2019年4月23日第十三届全国人民代表大会常务委员会第十次会议《关于修改〈中华人民共和国建筑法〉等八部法律的决定》第四次修正）中第十条和第十一条的有对不可注册商标有详细说明，
                        <a href="https://cloud.baidu.com/doc/Market/s/vkd1blq61#%E5%93%AA%E4%BA%9B%E5%95%86%E6%A0%87%E5%90%8D%E7%A7%B0%E4%B8%8D%E8%83%BD%E6%B3%A8%E5%86%8C%E6%88%96%E4%BD%BF%E7%94%A8%EF%BC%9F" target="_blank">点此查看详情>></a>
                    </p>
                    <p v-else-if="item.type === 'array'">
                        <span v-for="(desItem, num) in item.des" :key="num">{{desItem}}</span>
                    </p>
                    <p v-else>{{item.des}}</p>
                    </div>
                </div>
                </div>
            </div>
            </product-intro>
        </Layout>
    </div>
</template>

<script>
import Layout from '../components/Layout.vue';
import ProductBuy from '../components/ProductBuy.vue';
import ProductIntro from '../components/ProductIntro.vue';
import tmsCreate from '../assets/tms_create.png';
import tmsBaohu from '../assets/tms_baohu.png';
import tmsZizhi from '../assets/tms_zizhi.png';
import tmsZichan from '../assets/tms_zichan.png';
import tmsQuanwei from '../assets/tms_quanwei.png';
import tmsShengxin from '../assets/tms_shengxin.png';
import tmsKuaijie from '../assets/tms_kuaijie.png';
import tmsKekao from '../assets/tms_kekao.png';
import userApply from '../assets/user_apply.png';
import companyApply from '../assets/company_apply.png';
import selfIcon from '../assets/self_icon.png';
import auxiliaryIcon from '../assets/auxiliary_icon.png';
import guaranteeIcon from '../assets/guarantee_icon.png';
import icePrice from '../assets/ice_price.png';

import DATA from '../common/data.js';

export default {
    components: {
        Layout,
        ProductBuy,
        ProductIntro
    },
    metaInfo: {
        title: '商标注册服务_商标查询_商标担保注册_商标专家辅助注册_商标自助申请——百度智能云',
        meta: [
            {
                name: 'keywords',
                content: '商标注册,商标申请,商标查询,商标专家服务,商标担保注册,商标注册多少钱,怎么查询商标',
            },
            {
                name: 'description',
                content: '百度智能云商标注册服务提供商标自助查询、自助申请、专家辅助申请、全额担保申请等多种类型服务，资深专家指导，全流程透明，极速递交管局，配套提供搜索“保”字标识等多种百度生态权益，商标申请更安心',
            }
        ]
    },
    data () {
        return {
        baseInfo: {
            icon: selfIcon,
            title: '商标自助申请注册',
            des: '适用于有一定商标申请经验并能自主评估风险的用户',
            price: '270元',
            unit: '/件起',
            priceIcon: icePrice,
            originPrice: '300元/件起',
            advantage: [
            '自助办理，极速递交',
            '0服务费，直击底价',
            '专业审核，降低风险'
            ],
            serviceAdvantage: [
            '智能自助办理，快至一分钟递交',
            '全网优势价格，商标图样自动生成',
            '申请材料严格审核，降低不予受理风险'
            ]
        },
        infos: {
            self: {
                icon: selfIcon,
                title: '商标自助申请注册',
                des: '适用于有一定商标申请经验并能自主评估风险的用户',
                price: '270元',
                originPrice: '300元/件起',
                serviceAdvantage: [
                    '智能自助办理，快至一分钟递交',
                    '全网优势价格，商标图样自动生成',
                    '申请材料严格审核，降低不予受理风险'
                ],
                advantage: [
                    '自助办理，极速递交',
                    '0服务费，直击底价',
                    '专业审核，降低风险'
                ]
            },
            auxiliary: {
                icon: auxiliaryIcon,
                title: '商标专家辅助注册',
                des: '适用于需求急迫且商标风险评估、类别选择无经验的新用户',
                price: '499元',
                originPrice: '680元/件起',
                serviceAdvantage: [
                    '权威在先近似商标排查，成功率更高',
                    '1小时内响应需求服务，提交更快速',
                    '全流程专业顾问代办，注册更放心'
                ],
                advantage: [
                    '专家一对一全程服务',
                    '流程全代办，申请更高效',
                    '权威分析优化注册方案'
                ]
            },
            guarantee: {
                icon: guaranteeIcon,
                title: '商标至尊无忧注册',
                des: '适用于需求急迫且商标风险评估、类别选择无经验的新用户',
                price: '998元',
                originPrice: '1380元/件起',
                serviceAdvantage: [
                    '权威在先近似商标排查，成功率更高',
                    '全流程专业顾问代办，注册更放心',
                    '最高程度规避注册风险，实审失败可退款'
                ],
                advantage: [
                    '专家一对一全程服务',
                    '流程全代办，申请更高效',
                    '实审失败全额退款担保'
                ]
            }
        },
        selectDatasource: [
            {
            text: '商标自助注册',
            value: 'self'
            },
            {
            text: '专家辅助注册',
            value: 'auxiliary'
            },
            {
            text: '至尊无忧注册',
            value: 'guarantee'
            }
        ],
        typeSelected: 'self',
        intro: [
            {
            title: '品牌创建',
            des: '区别商品或服务出处；引导消费者认知品牌消费的习惯；商业影响力至关重要的地位',
            icon: tmsCreate
            },
            {
            title: '品牌保护',
            des: '有利于保护公司无形资产；避免行业内恶性竞争；防止同品类企业侵权',
            icon: tmsBaohu
            },
            {
            title: '必备资质',
            des: '企业拓展网络营销宣传资质要求；入驻天猫、京东、唯品会等电商平台；进入大商场或超市销售',
            icon: tmsZizhi
            },
            {
            title: '无形资产',
            des: '新颖创意的商标注册，具有非常高的经济利益；商标可作为无形资产进行质押贷款',
            icon: tmsZichan
            }
        ],
        advantage: [
            {
            icon: tmsQuanwei,
            title: '专业服务更权威',
            des: '资深商标顾问提供专业商标检索、商标注册申请代办和在线商标咨询服务'
            },
            {
            icon: tmsShengxin,
            title: '无忧注册更省心',
            des: '商标申报材料由专业顾问整理、填报，所有流程专人代办（限专家注册服务）'
            },
            {
            icon: tmsKuaijie,
            title: '极速递交更快捷',
            des: '商标申请资料极速申报，快至1分钟递交商标局，1-2个工作日拿到注册号'
            },
            {
            icon: tmsKekao,
            title: '品质保证更可靠',
            des: '更高的商标注册成功率和更精准的商标注册结果，商标服务质量有保证'
            }
        ],
        process: {
            auxiliary: [
            {
                title: '专家辅助下单',
                des: '提交商标需求，专家1小时内提供服务'
            },
            {
                title: '创建订单',
                des: '2小时确定商标注册方案，全程指导'
            },
            {
                title: '递交商标局',
                des: '材料完整当天递交，1-2天出注册号'
            },
            {
                title: '商标局形审',
                des: '获得受理通知书，商标局形审1-2个月'
            },
            {
                title: '注册成功',
                des: '下发商标证书，全程耗时约12个月'
            }
            ],
            self: [
            {
                title: '自助下单',
                des: '进行商标查询，自助下单完善申请材料'
            },
            {
                title: '平台审核',
                des: '平台审核申请材料，帮助规避近似风险'
            },
            {
                title: '递交商标局',
                des: '材料完整当天递交，1-2天出注册号'
            },
            {
                title: '商标局形审',
                des: '获得受理通知书，商标局形审1-2个月'
            },
            {
                title: '注册成功',
                des: '下发商标证书，全程耗时约12个月'
            }
            ]
        },
        materials: [
            {
            title: '公司申请',
            des: [
                '代理委托书盖章',
                '企业营业执照扫描件盖章'
            ],
            icon: userApply
            },
            {
            title: '个人申请',
            des: [
                '代理委托书盖章',
                '个体工商户营业执照扫描件盖章',
                '身份证正反面扫描件签字'
            ],
            icon: companyApply
            }
        ],
        problem: [
            {
            title: '哪些商标名称不能注册或使用？',
            type: 'cantRegis'
            },
            {
            title: '商标注册有风险吗？',
            type: 'array',
            des: [
                '商标注册存在一定风险，商标注册申请人要充分了解商标注册的风险，并在申请时做好应对准备。应对建议以下：',
                '申请时将中文、英文、图形等分开申请，通过后可以组合使用，以避免因某一部分近似而被商标局整体驳回的情况，且分开申请可以根据场景灵活组合使用。',
                '准备备用方案，申请时可以在主要商标申请方案的基础上，增加一到两件备用商标，以便在主商标无法通过或部分通过的情况下，有其他可以使用的商标。',
                '如无商标注册相关经验，建议使用专家辅助注册或全额担保注册。'
            ]
            },
            {
            title: '申请商标时，是黑白图样的还是彩色图样？',
            type: 'array',
            des: [
                '申请商标最好采用黑白图样申请。',
                '若申请时采用黑白图样申请，属于不指定颜色的申请。在商标注册成功后，注册人可以根据使用场景和需求改变申请商标的颜色，均被视为注册商标。',
                '若申请时指定颜色，在商标注册成功后，只有按照申请时颜色相同的图样进行使用，才可以使用注册商标的标识，改变颜色的使用方式属于不规范使用。'
            ]
            },
            {
            title: '商标注册时长问题',
            type: 'array',
            des: [
                '自商标递交之日起，需要经过形式审查、实质审查及初步审定公告，若商标审查顺利，无补正、驳回、异议等意外情况，按照目前的实务审查情况，12个月左右可以领取到《商标注册证》，最终以商标局审查进度为准。',
                '提交商标局之后，1-2天生成注册号（申请号）与PDF回执；',
                '形式审查阶段，自递交之日起1个月左右，出受理通知书；',
                '实质审查阶段，自形式审查通过后6~9个月出初审结果（驳回/部分驳回/初审公告）；',
                '初审公告期，公告时间为3个月；',
                '公告期结束之后的1-2个月下商标证书。'
            ]
            }
        ]
        }
    },
    methods: {
        onSelectType(item) {
            this.typeSelected = item.value;
            Object.assign(this.baseInfo, this.infos[this.typeSelected]);
        },
        onBuy() {
            let typeSelected = this.typeSelected;
            window.location.href = DATA.URL[typeSelected];
        },
        onAsk() {
            window.open('http://webui.im.bdymkt.com/pageinfo.jsp?version=vip&admiuin=9371462&ltype=1&iscallback=1&page_templete_id=40664&is_message_sms=0&is_send_mail=0&action=acd&acd=1&type_code=1');
        }
    }
}
</script>

<style lang="less">
.tms-intro-title {
    background-image: url(../assets/tms_title_bac.png);
}
.tms-intro {
    width: 823px;
    display: flex;
    justify-content: space-between;
    margin: 35px auto 55px;
    .tms-intro-item {
        width: 188px;
        position: relative;
    }
    img {
        width: 188px;
        height: 243px;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
    }
    .tms-intro-text {
        position: relative;
        z-index: 10;
        padding: 107px 16px 16px;
    }
    h4 {
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 22px;
        color: #191C3D;
        margin-bottom: 13px;
        text-align: center;
    }
    p {
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #191C3D;
        opacity: 0.6;
    }
}
.tms-advantage {
    width: 820px;
    display: flex;
    justify-content: space-between;
    flex-wrap: wrap;
    margin: 42px auto 46px;
    .tms-advantage-item {
        width: 392px;
        height: 134px;
        background: #FFFFFF;
        padding: 16px;
        margin-bottom: 30px;
        position: relative;
        img {
        width: 392px;
        height: 134px;
        display: block;
        position: absolute;
        top: 0;
        left: 0;
        }
        .tms-advantage-text {
        position: relative;
        z-index: 10;
        h4 {
            height: 25px;
            font-size: 18px;
            font-family: PingFang SC;
            font-weight: 500;
            line-height: 25px;
            color: #FFFFFF;
        }
        .line {
            width: 29px;
            height: 2px;
            background-color: #FFFFFF;
            margin: 11px 0 19px;
        }
        p {
            font-size: 14px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 20px;
            color: #FFFFFF;
        }
        }
    }
}
.tms-process {
    width: 820px;
    padding-top: 15px;
    margin: 0 auto;
    .process-title-img {
        width: 134px;
        height: 35px;
        display: block;
    }
    .process-auxiliary-img {
        margin: 26px auto 12px;
        display: block;
        width: 711px;
        height: 55px;
    }
    .tms-process-content {
        display: flex;
        justify-content: space-between;
        width: 750px;
        margin: 0 auto;
    }
    .tms-process-item {
        position: relative;
        h4 {
        height: 22px;
        font-size: 16px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 22px;
        color: #191C3D;
        text-align: center;
        }
        p {
        height: 64px;
        font-size: 14px;
        font-family: PingFang SC;
        font-weight: 400;
        line-height: 20px;
        color: #191C3D;
        opacity: 0.5;
        width: 84px;
        margin: 8px auto 0;
        }
    }
    .point-img {
        position: absolute;
        width: 83px;
        height: 12px;
        right: -83px;
        top: 6px;
    }
}
.tms-auxiliary-process {
    background-color: #fff;
    margin-top: 40px;
    .tms-process-item {
        padding-bottom: 24px;
    }
}
.tms-self-process {
    background-color: #fff;
    margin: 50px auto 62px;
    .tms-process-item {
        margin-top: 20px;
        padding-bottom: 24px;
    }
}
.tms-materials {
    width: 820px;
    margin: 62px auto;
    display: flex;
    justify-content: space-between;
    .tms-materials-item {
        position: relative;
        width: 395px;
        height: 187px;
        img {
        position: absolute;
        top: 0;
        left: 0;
        width: 395px;
        height: 187px;
        }
        h4 {
        height: 30px;
        font-size: 18px;
        font-family: PingFang SC;
        font-weight: 500;
        line-height: 30px;
        color: #FFFFFF;
        text-align: center;
        margin-bottom: 14px;
        position: relative;
        z-index: 10;
        }
        .materials-text {
        position: relative;
        z-index: 10;
        padding-left: 59px;
        height: 120px;
        display: flex;
        flex-direction: column;
        justify-content: center;
        p {
            height: 22px;
            font-size: 16px;
            font-family: PingFang SC;
            font-weight: 400;
            line-height: 22px;
            color: #FFFFFF;
            position: relative;
            margin-bottom: 9px;
        }
        p:before {
            content: '';
            position: absolute;
            left: -10px;
            top: 9px;
            width: 4px;
            height: 4px;
            background: #fff;
            display: block;
            border-radius: 50%;
        }
        }
    }
}
.tms-problem {
    .problem-item {
        p span {
            margin: 8px 0;
        }
    }
}
</style>
